'use client';
import {
  ActionIcon,
  Avatar,
  Button,
  Center,
  Group,
  SimpleGrid,
  Stack,
  Text,
  Title,
  rem,
} from '@mantine/core';
import { useTranslations } from 'next-intl';
import QuestionIcon from '@/assets/icons/question.svg';
import { assetPrefix } from '@/lib/constants';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';

export type TransportationDocumentsModalProps = {
  onClose: () => void;
  onConfirm: () => void;
};

export const transportDocsUrl =
  'https://ahamove.com/huong-dan-chuan-bi-chung-tu-di-duong';

const TransportationDocumentsModal = ({
  onClose,
  onConfirm,
}: TransportationDocumentsModalProps) => {
  const tActions = useTranslations('common.actions');
  const isMobile = useIsMobile();

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <>
      <Center>
        <Avatar
          radius="md"
          variant="outline"
          size={rem(148)}
          flex="none"
          src={`${assetPrefix}/static/images/transportation-documents.webp`}
          alt="Xác nhận chứng từ đi đường"
          styles={{
            placeholder: {
              border: 'none',
            },
          }}
        ></Avatar>
      </Center>

      <Stack gap={rem(12)} my={rem(24)}>
        {!isMobile ? (
          <Group gap={rem(8)} align="center">
            <Title order={3} c="neutral.7">
              Xác nhận chứng từ đi đường
            </Title>
            <ActionIcon
              variant="transparent"
              aria-label="Hướng dẫn chứng từ đi đường"
              onClick={() => window.open(transportDocsUrl, '_blank')}
            >
              <QuestionIcon />
            </ActionIcon>
          </Group>
        ) : null}

        <Text c="neutral.7" fw={500}>
          Để đảm bảo tính hợp pháp và minh bạch trong quá trình vận chuyển hàng
          hóa, <strong>đơn hàng này bắt buộc phải có chứng từ đi đường </strong>
          theo quy định của thông tư số 73-TC/TCT.
        </Text>

        <Text c="neutral.7" fw={500}>
          Nếu chưa có chứng từ đi đường, bạn có thể tải về mẫu chứng từ đi đường{' '}
          <Text
            component="a"
            href={`${assetPrefix}/static/files/transportation-documents.xlsx`}
            download
            c="blue.4"
            fw={500}
            style={{ cursor: 'pointer', textDecoration: 'underline' }}
          >
            tại đây.
          </Text>
        </Text>
      </Stack>

      <SimpleGrid w="100%" cols={1} spacing="md">
        <Button
          fullWidth
          mih={rem(48)}
          radius={rem(4)}
          fw={700}
          onClick={handleConfirm}
        >
          {tActions('confirm')}
        </Button>
      </SimpleGrid>
    </>
  );
};

export default TransportationDocumentsModal;
